module.exports = __webpack_public_path__ + "img/3.89661d8b.jpg";